import styles from './billing-summary-row.module.css'

import React from 'react'

import { Flex, Text, VisuallyHidden } from 'components/ds'

import type { BillingPeriod } from './billing-period-row'
import SubscriptionRow from './subscription-row'

export type BillingSummaryDiscount = {
  label: string
  amount: string
}

type Props = {
  /** Null for periods the app doesn't support yet, which leaves out how often it's billed */
  period: BillingPeriod | null
  /** Next renewal date, already formatted */
  renewsOn: string
  /** Amount due at the next renewal, already formatted in the subscription currency */
  amount: string
  /** Amount before the listed discounts, already formatted */
  amountBeforeDiscounts?: string | null
  discounts?: BillingSummaryDiscount[]
}

/** Amount due at the next renewal. */
const BillingSummaryRow = ({
  period,
  renewsOn,
  amount,
  amountBeforeDiscounts,
  discounts = [],
}: Props): React.ReactNode => {
  return (
    <SubscriptionRow
      title="Billing summary"
      subtitle={`Amount due on ${renewsOn}`}
      emphasised
      aside={
        <Flex direction="column" align="end" gap="1">
          {discounts.map((discount, index) => (
            <Flex key={`${discount.label}-${index}`} align="center" gap="4">
              <Text size="1" color="green">
                <Text weight="bold" className={styles.discountPrefix}>
                  Discount:
                </Text>{' '}
                {discount.label}
              </Text>
              <Text size="1" color="green" weight="bold">
                {discount.amount}
              </Text>
            </Flex>
          ))}
          <Flex align="center" gap="2">
            {amountBeforeDiscounts && (
              <Text size="2" color="gray">
                <VisuallyHidden>Original amount: </VisuallyHidden>
                <del>{amountBeforeDiscounts}</del>
              </Text>
            )}
            <Text size="2" weight="bold">
              <VisuallyHidden>Amount due: </VisuallyHidden>
              {amount}
            </Text>
          </Flex>
          {period && (
            <Text size="1" color="gray">
              {period === 'annual' ? 'Billed annually' : 'Billed monthly'}
            </Text>
          )}
        </Flex>
      }
    />
  )
}

export default BillingSummaryRow
